/**
 * The `SortableOnDragEndEvent` event.
 */
var SortableOnDragEndEvent = /** @class */ (function () {
    /**
     * @hidden
     */
    function SortableOnDragEndEvent(target, prevIndex, nextIndex, newState) {
        this.target = target;
        this.prevIndex = prevIndex;
        this.nextIndex = nextIndex;
        this.newState = newState;
    }
    return SortableOnDragEndEvent;
}());
export { SortableOnDragEndEvent };
//# sourceMappingURL=SortableOnDragEndEvent.js.map